import { DateTime, DateTimeOptions } from "luxon";

/**
 * Converts various date inputs into a Luxon DateTime object.
 * Supports DateTime, Date, string, and number inputs.
 *
 * @param date - The input date: ISO string, JS Date, number (timestamp), or Luxon DateTime.
 * @param options - Optional Luxon parsing options (e.g. zone, locale).
 * @returns A Luxon DateTime object (can be invalid).
 */
const toDateTime = (
    date: DateTime | Date | string | number,
    options?: DateTimeOptions
): DateTime => {
    if (DateTime.isDateTime(date)) {
        return date;
    }

    if (typeof date === "string") {
        return DateTime.fromISO(date, { ...options });
    }

    if (date instanceof Date) {
        return DateTime.fromJSDate(date, { ...options });
    }

    if (typeof date === "number") {
        return DateTime.fromMillis(date, { ...options });
    }

    return DateTime.invalid("Invalid input type");
};

export default toDateTime;
